export default __webpack_public_path__ + "static/media/09AW1FEB66.bc58f601.jpg";